module.exports = __webpack_public_path__ + "static/img/dailyd.75b9627.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dailyd.png
// module id = dmgg
// module chunks = 1